import { IncludeSurveyModel } from "../summary/summary.model";
import { SurveyFilterUIModel } from "../survey/survey.model";

export class SurveyUserSettingModel {
  id?: number;
  surveyId?: number;
  userId?: number;
  settingsJSON?: SettingsJSONModel;
  styleId?: number;
}

export class SettingsJSONModel
{
  surveySettings?: SurveySettingModel;
}

export class SurveySettingModel
{
  languageId?: number;
  questions?: SurveySettingQuestionModel[];
  filters?: SurveyFilterUIModel[];
  includeSurvey?: IncludeSurveyModel;
  smartAnalysis?: SurveySettingSmartAnalysisModel;
  isOrOperator?: string;

  constructor()
  {
    this.questions = this.questions || [];
    this.filters = this.filters || [];
  }
}

export class SurveySettingQuestionModel
{
  questionNo?: number;
  questionText?: string;
  chartType?: string;
  themeOn?: boolean;
  versions?: SurveySettingVersionModel[];

  constructor() {
      this.versions = this.versions || [];
  }
}

export class SurveySettingVersionModel
{
  isAllResponses?: boolean;
  versionId?: string;
  cutId?: number;
  sort?: string;
  typePercentageSelected?: string;
}

export class SurveySettingSmartAnalysisModel {
  standardDeviation: number;
  percentageDifferenceType: string;
  responseMin: number;
}



// WEBPACK FOOTER //
// ./src/app/models/survey-user-setting/survey-user-setting.model.ts